import { SignalDispatcher } from 'ste-signals';

export const customerEvents = {
  brandCreated: new SignalDispatcher(),
  brandUpdated: new SignalDispatcher(),
};
